import React, { useState } from 'react';
import {
    Sparkles, ChevronDown, Menu, X, Zap, FileTextIcon, ScaleIcon, ScanQrCodeIcon,
    Globe, DollarSign, MessageSquare, Calendar, MessageCircle, Layout, Search, Share2, Video,
    Users, GraduationCap, HeartHandshake, BookOpen, TrendingUp, Heart, FileQuestion, User, Phone,
    ChevronUp, Clock
} from 'lucide-react';
import { Link } from 'react-router-dom';
import GoogleTranslate from 'components/GoogleTranslate';
import CategoryDropdown from '../Dropdown';
import MobileMenu from '../MobileMenu';
import History from 'constants/history';
import { CardsCarouselProps } from '../card-carousel';
import { renderComponents } from 'pages/NewLandingPage';
import { Img } from 'components';
import { PATH, PREFIX } from 'utils';


export const optionsforYourAiEmployee = [
    {
        id: 'digital-marketing',
        name: 'Digital Marketing',
        options: [
            { icon: Layout, text: 'Instant Responsive Website Developer', badge: null },
            { icon: Search, text: 'SEO Specialist', badge: null },
            { icon: Share2, text: 'Social Media Manager', badge: null },
            { icon: Video, text: 'Automated Reels & Video Generator', badge: null },
            { icon: Users, text: '24/7 Virtual Admission Counsellor', badge: null },
        ],
        // path: PATH_FOR_DIGITAL_MARKETING,
        prefix: PREFIX.D_MARKETING_PREFIX,
        prefixPath: PATH.PATH_FOR_DIGITAL_MARKETING+"#"+PREFIX.D_MARKETING_PREFIX
    },
    {
        id: 'teachers',
        name: 'Teachers',
        options: [
            { icon: GraduationCap, text: 'SuperStudent', badge: 'Coming soon' },
            { icon: HeartHandshake, text: 'Parent Helpdesk', badge: null },
            { icon: BookOpen, text: 'Child Care', badge: null },
            { icon: TrendingUp, text: '1st Rank', badge: null },
        ],
        // path: PATH_FOR_TEACHER,
        prefix: PREFIX.TEACHER_PREFIX,
        prefixPath: PATH.PATH_FOR_TEACHER+"#"+PREFIX.TEACHER_PREFIX
    },
    {
        id: 'operations',
        name: 'Operations',
        options: [
            { icon: Globe, text: 'Multilingual Communication', badge: null },
            { icon: DollarSign, text: 'Auto Fee Collection', badge: null },
            { icon: MessageSquare, text: 'Parental Feedback', badge: null },
            { icon: Calendar, text: 'AI-Daily Tasks', badge: null },
            { icon: MessageCircle, text: 'AI-Chat', badge: null },
        ],
        // path: PATH_FOR_OPERATOR,
        prefix: PREFIX.OPERATOR_PREFIX,
        prefixPath: PATH.PATH_FOR_OPERATOR+"#"+PREFIX.OPERATOR_PREFIX
    },
    {
        id: 'self-healing-support',
        name: 'Self-Healing Support',
        options: [
            { icon: Heart, text: 'Self Healer', badge: 'New' },
            { icon: FileQuestion, text: 'Record and Report', badge: null },
            { icon: User, text: 'Virtual Relationship Manager', badge: null },
            { icon: Phone, text: 'AI-WhatsApp Support', badge: null },
        ],
        // path: PATH_FOR_AI_SUPPORT,
        prefix: PREFIX.SUPPORT_PREFIX,
        prefixPath: PATH.PATH_FOR_AI_SUPPORT+"#"+PREFIX.SUPPORT_PREFIX
    }
];

const optionsForStartups = [
    { icon: Zap, text: 'Powering your school with Soomuch.AI', badge: null, prefix: PREFIX.STARTUP_PREFIX, path: PATH.PATH_FOR_STARTUP },
    { icon: FileTextIcon, text: 'Complete school marketing toolkit', badge: null },
    { icon: ScaleIcon, text: 'CS, CA and Legal Assistance', badge: null }
];

const optionsForAddons = [
    { icon: MessageCircle, text: 'AI Powered WhatsApp', badge: null, prefix: PREFIX.WHATSAPP_PREFIX, path: PATH.PATH_FOR_WHATSAPP },
    { icon: ScanQrCodeIcon, text: 'AI Powered ID Cards/QR Code', badge: null, prefix: PREFIX.IDCARD_PREFIX, path: PATH.PATH_FOR_ID_CARDS },
];

const menuItems = [
    { name: 'ABOUT US', "path": PATH.PATH_FOR_ABOUT_US },
    { name: 'YOUR AI EMPLOYEES', path: "" },
    { name: 'FOR STARTUPS', path: "" },
    { name: 'ADD ONS', path: "" },
    { name: 'BLOGS', path: "" },
    { name: 'PRESS', path: "" },
    { name: 'USE CASES', path: "" },
    { name: 'AI Live demo', path: "" },
];

const ComingSoonTooltip = ({ children }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            className="relative inline-block"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {children}
            {isHovered && (
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 z-50 animate-fadeIn">
                    <div className="bg-gradient-to-r from-[#E5542F] to-[#8431D6] text-[#eee9e9] px-4 py-2 rounded-lg shadow-xl whitespace-nowrap">
                        <div className="flex items-center gap-2">
                            <Clock className="w-4 h-4" />
                            <span className="font-light text-sm">Coming Soon</span>
                        </div>
                        <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-gradient-to-r from-[#E5542F] to-[#8431D6] rotate-45"></div>
                    </div>
                </div>
            )}
        </div>
    );
};

const Header: React.FC<CardsCarouselProps> = ({ sectionRefs, usePrefix }) => {

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            // behavior: 'smooth'
        });
    };

    const handleOptionClick = (option, categoryId) => {
        console.log('Option clicked:', option, categoryId);
        if(usePrefix && !!option.prefixPath) {
            console.log('Using prefix path navigation');
            History.navigate(option.prefixPath);
        } else if (!!option?.path) {
            console.log('Using direct path navigation');
            History.navigate(option?.path);
        } else if (!!option?.prefix) {
            console.log('Using section scroll navigation');
            const firstSectionIndex = renderComponents.findIndex(
                (comp) => comp.id && comp.id.startsWith(option?.prefix)
            );
            if (firstSectionIndex !== -1 && sectionRefs?.current[firstSectionIndex]) {
                const element = sectionRefs.current[firstSectionIndex];
                const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - 95; // Scroll 100px above the target

                window.scrollTo({
                    top: offsetPosition/* ,
                    behavior: "smooth" */
                });
            }
        } else {
            console.log('Else Clicked:', JSON.stringify(option), categoryId ? `from ${categoryId}` : '');
        }
    };


    React.useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(() => true);
            } else {
                setIsVisible(() => false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    return (
        <>
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Gabarito:wght@500&family=Instrument+Sans:wght@400;500;600;700&&family=Inter:wght@400;500;600;700&family=Poppins:wght@400;500;600;700&display=swap');
        
        @keyframes fadeIn {
            from {
                opacity: 0;
                transform: translateX(-50%) translateY(-5px);
            }
            to {
                opacity: 1;
                transform: translateX(-50%) translateY(0);
            }
        }
        
        .animate-fadeIn {
            animation: fadeIn 0.2s ease-out;
        }
           `}</style>
            <div className="relative mx-auto">
                <div className="bg-[#4949DE] text-[white] text-center py-2 px-4 text-xs sm:text-[10px]">
                    Exclusive: First-year access worth ₹5,00,000 — Free for selected schools (1% per state)
                </div>
                {/* Header */}
                <header className="grid grid-cols-[1fr_auto_1fr] items-center gap-4 px-2 py-[1vh] md:flex md:justify-between md:px-4">
                    {/* Left Section */}
                    <div onClick={() => History.navigate('/v2')} className="flex items-center gap-3">
                        <Img src="images/newRedLogo.svg" alt="Logo" className='cursor-pointer w-40' enableShimmer={false} />
                    </div>

                    {/* Center Section - Desktop Menu Items */}
                    <nav className="flex items-center gap-10 md:hidden font-bold justify-self-center" style={{ fontFamily: 'Gabarito, sans-serif', fontSize: '2vh' }}>
                        <button onClick={() => History.navigate(PATH.PATH_FOR_ABOUT_US)} type="button" className="flex items-center gap-1 text-gray-800">
                            ABOUT US
                        </button>
                        <CategoryDropdown
                            buttonText="YOUR AI EMPLOYEES"
                            categories={optionsforYourAiEmployee}
                            onOptionClick={handleOptionClick}
                        />
                        <CategoryDropdown
                            buttonText="FOR STARTUPS"
                            categories={optionsForStartups}
                            onOptionClick={handleOptionClick}
                            hoveredCategoryBg="bg-blue-50"
                            iconColor="text-blue-600"
                        />
                        <CategoryDropdown
                            buttonText="ADD ONS"
                            categories={optionsForAddons}
                            onOptionClick={handleOptionClick}
                            hoveredCategoryBg="bg-blue-50"
                            iconColor="text-blue-600"
                        />
                        <ComingSoonTooltip>
                            <button type="button" className="text-gray-800 cursor-not-allowed opacity-75 hover:opacity-100 transition-opacity">
                                BLOGS
                            </button>
                        </ComingSoonTooltip>
                        <ComingSoonTooltip>
                            <button type="button" className="text-gray-800 cursor-not-allowed opacity-75 hover:opacity-100 transition-opacity">
                                PRESS
                            </button>
                        </ComingSoonTooltip>
                        <ComingSoonTooltip>
                            <button type="button" className="flex items-center gap-1 text-gray-800 cursor-not-allowed opacity-75 hover:opacity-100 transition-opacity">
                                USE CASES <ChevronDown className={`w-4 h-4`} />
                            </button>
                        </ComingSoonTooltip>
                    </nav>

                    {/* Right Section */}
                    <div className="flex items-center gap-4 justify-self-end md:hidden">
                        <GoogleTranslate />
                        <Link to={"/explore"} type="button" className="bg-gradient-to-r from-[#E5542F] to-[#8431D6] text-[#eee9e9] px-[2vh] py-[1.2vh] rounded-full font-medium flex items-center gap-2 shadow-lg md:hidden" style={{ fontFamily: 'Poppins, sans-serif', fontSize: '2vh' }}>
                            <Sparkles className="w-5 h-5" fill="white" />
                            Live demo
                        </Link>
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="hidden md:block">
                        <button
                            type="button"
                            className="p-2 text-gray-700"
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        >
                            {mobileMenuOpen ? (
                                <X className="w-6 h-6" />
                            ) : (
                                <Menu className="w-6 h-6" />
                            )}
                        </button>
                    </div>
                </header>

                {/* Mobile Menu Dropdown */}
                <MobileMenu
                    isOpen={mobileMenuOpen}
                    menuItems={menuItems}
                    optionsForYourAiEmployee={optionsforYourAiEmployee}
                    optionsForStartups={optionsForStartups}
                    optionsForAddons={optionsForAddons}
                    onOptionClick={handleOptionClick}
                />
                {isVisible && (
                    <button
                        onClick={scrollToTop}
                        className="fixed bottom-8 right-8 bg-blue-600 hover:bg-blue-700 text-[white] p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 z-50"
                        aria-label="Scroll to top"
                        type='button'
                    >
                        <ChevronUp size={24} />
                    </button>
                )}
            </div>
        </>
    );
}

export default Header;